
export const getters = {
    request : state =>  state.request,
    response : state => state.response,
    confirm : state => state.confirm,
    recoveryCode : state => state.recoveryCode,
    recovery: state => state.recovery,
};